import React, {useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Link, useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import '../Modal/Createtemplate.scss'
import Iframe from 'react-iframe'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {useDispatch, useSelector} from 'react-redux'
import {BulkMsgDraftData} from '../../new-message/BulkMessageSlice/BulkMessageSlice'
import {getDefaultShortUrl} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const WebLink = ({
  show,
  handleClose,
  setBulkMessageData,
  bulkMessageData,
  inputRef,
  data,
  isDraft,
}: any) => {
  const dispatch = useDispatch()
  const [weblink, setWebLink] = useState('')
  const [shortUrl, setShortUrl] = useState('')
  const ShortLinkRef: any = useRef()
  const [error, setError] = useState({long: '', short: ''})
  const defaultShortUrl = useSelector(getDefaultShortUrl)

  const handleAddShortUrl = () => {
    let startSubString = bulkMessageData?.message?.slice(0, inputRef.current.selectionStart)
    let endSubString = bulkMessageData?.message?.slice(inputRef.current.selectionEnd)

    if (data?.longUrl !== '') {
      let previousMessage = bulkMessageData?.message
      let addAgain = startSubString + `${defaultShortUrl}/${data?.shortUrl}` + ' ' + endSubString
      const regex = /short\.cellcast\.com\/\w+/

      let finalDataOfLongUrl = [...bulkMessageData?.longUrl]?.map((key: any) => ({
        longUrl: key?.longUrl,
        shortUrl: key?.shortUrl,
      }))
      let longUrlData = bulkMessageData?.longUrl?.findIndex(
        (val: any) => val?.shortUrl === data?.shortUrl
      )

      finalDataOfLongUrl.splice(longUrlData, 1, {longUrl: weblink, shortUrl: shortUrl})

      if (previousMessage?.match(regex) == null) {
        setBulkMessageData({
          ...bulkMessageData,
          message: addAgain,
          longUrl: finalDataOfLongUrl,
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...bulkMessageData,
              message: addAgain,
              longUrl: finalDataOfLongUrl,
            })
          )
        }
      } else {
        let content = previousMessage?.replace(new RegExp('\\b' + data?.shortUrl + '\\b'), shortUrl)
        setBulkMessageData({
          ...bulkMessageData,
          message: content,
          longUrl: finalDataOfLongUrl,
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...bulkMessageData,
              message: content,
              longUrl: finalDataOfLongUrl,
            })
          )
        }
      }
    } else {
      let content = startSubString + `${defaultShortUrl}/${shortUrl}` + ' ' + endSubString

      if (!bulkMessageData.longUrl) {
        setBulkMessageData({
          ...bulkMessageData,
          message: content,
          longUrl: [{longUrl: weblink, shortUrl: shortUrl}],
        })
      } else {
        bulkMessageData?.longUrl?.length < 4 &&
          setBulkMessageData({
            ...bulkMessageData,
            message: content,
            longUrl: [...bulkMessageData?.longUrl, {longUrl: weblink, shortUrl: shortUrl}],
          })
      }

      if (isDraft) {
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            message: content,
            longUrl: [...bulkMessageData?.longUrl, {longUrl: weblink, shortUrl: shortUrl}],
          })
        )
      }
    }
    // TODO: disable ref it make blank screen
    // inputRef?.current.focus()
    handleClose()
  }

  useEffect(() => {
    if (data?.longUrl !== '') {
      setWebLink(data?.longUrl?.trim())
      setShortUrl(data?.shortUrl?.trim())
    } else {
      setWebLink('')
      setShortUrl('')
    }
  }, [data])

  const getRandomChars = (inputString: any, count: any) => {
    let result = ''

    if (count <= inputString?.length) {
      const shuffled = inputString?.slice(0, 3)
      result = shuffled
    }

    return result
  }
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-450px h-200px'
        show={show}
        onHide={handleClose}
      >
        <div className='add_sort_url'>
          <div className=''>
            <div className='modal-header'>
              <h2>Add short URL</h2>
              <div className='btn btn-icon btn-sm ' onClick={handleClose}>
                <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
            <div className='modal-body p-16 py-11'>
              <div className='web_left'>
                <div className='mb-3 weblink_status_main'>
                  <div className='d-flex justify-content-between'>
                    <label className='form-label'>Weblink URL</label>
                    {/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                      weblink
                    ) && (
                      <KTSVG
                        className='svg-icon-1'
                        onClick={() => {
                          if (!weblink.startsWith('http://') && !weblink.startsWith('https://')) {
                            // If not, prepend https:// to the URL
                            const newLink = 'https://' + weblink
                            window.open(newLink)
                          } else {
                            window.open(weblink)
                          }
                        }}
                        path='/media/icons/duotune/art/view-link.svg'
                      />
                    )}
                  </div>
                  <input
                    type='text'
                    className='form-control form-control-solid border-0'
                    placeholder='https://yoursite.com'
                    name='name'
                    value={weblink}
                    onBlur={() => {
                      const hostName = weblink.match(/^(?:https?:\/\/)?(?:www\.)?([^:\/\n?]+)/)?.[1]
                      const name = getRandomChars(hostName, 3)
                      setShortUrl(name?.trim())

                      const checkDuplicateShortUrl = bulkMessageData?.longUrl?.find(
                        (it: any) => it?.shortUrl?.toLowerCase() === name?.trim()
                      )
                      if (checkDuplicateShortUrl) {
                        setError({...error, short: 'Please enter Unique code '})
                      } else {
                        setError({...error, short: ''})
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value
                      setWebLink(value?.trim())
                      if (
                        /https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                          value?.trim()
                        )
                      ) {
                        setError({...error, long: ''})
                      } else {
                        setError({...error, long: 'Please enter valid alphanumeric characters'})
                      }
                    }}
                  />
                  {/* <span>Eg:https://example.com</span> */}
                  <span
                    className={`weblink_status ${
                      weblink !== ''
                        ? /https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(
                            weblink
                          )
                          ? 'valid'
                          : 'invalid'
                        : ''
                    }`}
                  >
                    {/* <KTSVG path='/media/misc/check-circle.svg' className='svg-icon' /> */}

                    {/* <KTSVG path='/media/misc/cross-square.svg' className='svg-icon ' /> */}
                  </span>
                </div>

                <span className='link_text additional_url input-group'>
                  <span>Your short link is </span>
                  <a className='fw-light ms-1'>{'go-site.cc/'}</a>
                  <input
                    value={shortUrl}
                    ref={ShortLinkRef}
                    className='form-control form-control-solid border-0'
                    placeholder=''
                    onChange={(e: any) => {
                      const value = e.target.value
                      let uniqueCode = bulkMessageData?.longUrl?.map((key: any) => key?.shortUrl)
                      setShortUrl(value?.trim())
                      if (/^[a-zA-Z0-9]{3,24}$/.test(value?.trim())) {
                        uniqueCode?.includes(value?.trim())
                          ? setError({...error, short: 'Please enter Unique code '})
                          : setError({...error, short: ''})
                      } else {
                        setError({...error, short: 'Please enter valid URL'})
                      }
                    }}
                    maxLength={25}
                  />
                  <div className='input-group-append'>
                    <span>-x</span>
                  </div>

                  <button
                    onClick={() => ShortLinkRef?.current.focus()}
                    className='btn btn-sm gray_bg_purple px-3 py-2'
                    type='button'
                  >
                    Edit
                  </button>
                </span>
                <span className='text-danger'>{error.short}</span>

                <div className='d-flex  align-items-end justify-content-end mt-10'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      className='btn btn-sm gray_bg_purple py-3'
                      type='button'
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={
                        error.long !== '' ||
                        error.short !== '' ||
                        shortUrl == '' ||
                        !/^[a-zA-Z0-9]{3,24}$/.test(shortUrl)
                      }
                      type='submit'
                      className='btn btn-sm btn-light btn-primary ms-2 me-2 w-60px p-3 fw-500 me-2'
                      onClick={handleAddShortUrl}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className='web_right'>
                {weblink !== '' && (
                  <div className='ulr_box_inner'>
                    <Iframe
                      url={weblink}
                      width='100%'
                      height='100%'
                      id=''
                      className=''
                      display='block'
                      position='relative'
                    />
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default WebLink
